import { render, staticRenderFns } from "./loadingWheel.vue?vue&type=template&id=573a904c&scoped=true&"
import script from "./loadingWheel.vue?vue&type=script&lang=js&"
export * from "./loadingWheel.vue?vue&type=script&lang=js&"
import style0 from "./loadingWheel.vue?vue&type=style&index=0&id=573a904c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573a904c",
  null
  
)

export default component.exports